import React from 'react'
import CustomModal from 'components/global/CustomModal'
import AdultImage from 'assets/Images/adult.png'
import KidImage from 'assets/Images/kid-ico.png'
import { eventAttendanceStore } from 'state/event/eventAttendance'
import { kidStore } from 'state/family/kid'
import { adultStore } from 'state/family/adult'

interface AddMemberProps {}

const AddMember: React.FC<AddMemberProps> = ({}) => {
  const { addNewMemberModalOpen, setAddNewMemberModalOpen } =
    eventAttendanceStore(store => ({
      addNewMemberModalOpen: store.addNewMemberModalOpen,
      setAddNewMemberModalOpen: store.setAddNewMemberModalOpen,
    }))

  const { setKidCreationModal } = kidStore(store => ({
    setKidCreationModal: store.setKidCreationModal,
  }))
  const { setAdultCreationModal } = adultStore(store => ({
    setAdultCreationModal: store.setAdultCreationModal,
  }))

  const handleAddKid = () => {
    setKidCreationModal(true)
    setAddNewMemberModalOpen(false)
  }

  const handleAddAdult = () => {
    setAdultCreationModal(true)
    setAddNewMemberModalOpen(false)
  }

  return (
    <>
      <CustomModal
        openModal={addNewMemberModalOpen}
        closeModal={setAddNewMemberModalOpen}
        title="Choose member"
        footer={false}
      >
        <div className="flex gap-40px justify-center align-center ">
          <button
            className="radius-12 py-20px px-30px pointer"
            onClick={handleAddKid}
          >
            <img src={KidImage} alt="kid" width={100} height={100} />
            <p className="mt-10px">kid</p>
          </button>
          <button
            className="radius-12 py-20px px-30px pointer"
            onClick={handleAddAdult}
          >
            <img src={AdultImage} alt="adult" width={100} height={100} />
            <p className="mt-10px">Adult</p>
          </button>
        </div>
      </CustomModal>
    </>
  )
}

export default AddMember
